<script setup>
import { computed } from 'vue'

const props = defineProps({
  amount: {
    required: true
  },
  currency: {
    type: String,
    default: 'FIO'
  },
  locale: {
    type: String,
    default: 'it-IT'
  },
})

// Convert amount to number if it's a string
const numericAmount = computed(() => {
  if (typeof props.amount === 'string') {
    const parsed = parseFloat(props.amount)
    return isNaN(parsed) ? 0 : parsed
  }
  return props.amount
})

const formattedAmount = computed(() => {
  let formatted
  const amount = numericAmount.value
  
  if (props.currency === 'FIO') {
    // Valuta fittizia: Fiorini
    formatted = `${Math.abs(amount).toLocaleString(props.locale)} ⚜`
  } else {
    // Valute reali
    formatted = new Intl.NumberFormat(props.locale, {
      style: 'currency',
      currency: props.currency
    }).format(Math.abs(amount))
  }
  
  if (amount !== 0) {
    return amount > 0 ? `${formatted}` : `-${formatted}`
  }
  
  return formatted
})


</script>

<template>
  <span>{{ formattedAmount }}</span>
</template>